module.exports = __webpack_public_path__ + "static/img/news-qrcode.1342bff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-qrcode.png
// module id = F47w
// module chunks = 1